"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
rxjs_1.Observable.of = rxjs_1.of;
//# sourceMappingURL=of.js.map